import Success from "./Success";

export default function HomeSuccess() {
    return <Success link="/" message="Homepage" />;
}
